export * from './normalizeResult';
export * from './normalizerService';